import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-digital-card-passcode',
  templateUrl: './digital-card-passcode.component.html',
  styleUrls: ['./digital-card-passcode.component.scss'],
  host: {
    class: 'app-digital-card-passcode'
  },
  standalone: false
})
export class DigitalCardPasscodeComponent {

  @Input() visible: boolean = false;
  @Input() loading: boolean = false;
  @Input() errorMessage: string | null = null;

  @Output() passcodeSubmit = new EventEmitter<string>();

  passcodeForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.passcodeForm = this.fb.group({
      securityPasscode: ['', Validators.required]
    });
  }

  onSubmitPasscode() {
    if (this.loading) {
      return;
    }

    this.passcodeForm.markAllAsTouched();

    if (this.passcodeForm.invalid) {
      return;
    }

    const securityPasscode = this.passcodeForm.controls['securityPasscode'].value;

    if (securityPasscode.trim().length === 0) {
      this.passcodeForm.controls['securityPasscode'].setErrors({
        required: true
      });

      return;
    }

    this.passcodeSubmit.emit(securityPasscode);
  }
}
